import { useMemo } from 'react';
import {
  isMobileDevice,
  isWorkflowRestrictedOnMobile,
} from '../utils/mobileRestrictions';
import { PageState } from './usePageState';

// ============= Hook =============
/**
 * Custom hook to handle mobile restrictions
 * Extracts mobile restriction logic from BodyLayout
 */
export const useMobileRestriction = (pageState: PageState) => {
  const isMobile = useMemo(() => isMobileDevice(), []);

  const restrictedWorkflowKey = useMemo(() => {
    if (!pageState.isWorkflowPage) return null;
    // Extract workflow key from the current path
    const pathParts = window.location.pathname.split('/');
    if (pathParts.length > 2) return pathParts[2];
    return null;
  }, [pageState.isWorkflowPage]);

  const isRestrictedOnMobile = useMemo(
    () => isMobile && isWorkflowRestrictedOnMobile(restrictedWorkflowKey),
    [isMobile, restrictedWorkflowKey]
  );

  return {
    isMobile,
    isRestrictedOnMobile,
  };
};
